<template>
  <div class="content">
    <div class="indexHeader">
      <div class="headerText">
        <p class="sage-content">{{ $t("web.sage-content") }}</p>
        <h1 class="sage-content-sub" v-if="ruFlag">{{ $t("web.sage-content-sub") }}</h1>
      </div>
      <dev class="headerImg">
      </dev>
    </div>
    <div class="card-content">
      <div class="card-content-sub">
        <goods/>
      </div>
    </div>
    <PromotionalSlogan />
    <div class="blog-card">
      <blog></blog>
    </div>
    <div class="comments-content">
      <comments></comments>
    </div>
    <div class="faq-content">
      <faqContent></faqContent>
    </div>
    <div class="goods-content" v-if="carListShow">
      <carList></carList>
    </div>
    <div class="loadingFlag" v-if="this.loadingFlag">
      <CustomLoading/>
    </div>
  </div>
</template>
  <script>
  import {mapActions, mapState} from "vuex";
  const { defineAsyncComponent } = Vue;
  export default {
    name: "Index",
    components: {
      // PromotionalSlogan 是直接导入的组件,会被打包到主包中,加载速度更快
      // 其他组件使用异步加载,会被单独打包成独立的chunk文件,按需加载,减小主包体积
      CustomLoading: defineAsyncComponent(() => import(/* webpackChunkName: "customLoading" */ '@/components/CustomLoading.vue')),
      CarList: defineAsyncComponent(() => import(/* webpackChunkName: "carList" */'@/components/CarList.vue')),
      goods: defineAsyncComponent(() => import(/* webpackChunkName: "goods" */'@/components/Goods.vue')),
      Comments:defineAsyncComponent(() => import(/* webpackChunkName: "comments" */'@/components/Comments.vue')),
      blog:defineAsyncComponent(() => import(/* webpackChunkName: "blog" */'@/components/Blog .vue')),
      faqContent: defineAsyncComponent(() => import(/* webpackChunkName: "faq" */'@/components/FAQ.vue')),
      PromotionalSlogan: defineAsyncComponent(() => import(/* webpackChunkName: "promotionalSlogan" */'@/components/PromotionalSlogan.vue'))
    },
    data() {
      return {
        ruFlag: true
      }
    },
    computed: {
      ...mapState(['carListShow', 'loadingFlag'])
    },
    created() {
      // this.updateLanguage()
      this.initRuFlag();
    },
    mounted() {
      this.checkOpenCarList();
    },
    methods: {
      ...mapActions(['updateCarList', 'updateCarListShow', 'updatePriceGroupByIntervalType', 'updateOldTransactionKey']),
      closeDetail() {
        this.$store.dispatch('updateCarListShow', false);
      },
      async initRuFlag() {
        let language = this.$cookies.get("sbox-l")
        if (language === 'ru') {
          this.ruFlag = false;
        }
      },
      checkOpenCarList() {
        let renewal = this.$route.query.renewal_id || null
        if (renewal !== null) {
          let oldTransactionKey = null;
          // this.$store.dispatch('getOldOrderInfo', {oldTransactionKey, renewal})
          // this.getOldOrderInfo({oldTransactionKey, renewal});
          let url = '/api/renewal_order/email-open-renewal-order/' + renewal
          this.$axios.get(url)
              .then(resp => {
                let respData = resp.data;
                if (respData.code !== 100000 || respData.data === null || respData.data === undefined) {
                  this.$message({
                    type: 'error',
                    message: respData.message
                  });
                  return;
                }
                let carList = respData.data;
                let price_list = carList.price_list;
                let priceGroupByIntervalType = price_list.reduce((acc, item) => {
                  // const key = item.interval_type
                  const key = item.goods_used_interval_count + " " + item.goods_used_interval_type;
                  if (!acc[key]) {
                    acc[key] = [];
                  }
                  acc[key].push(item);
                  return acc;
                }, {})
                this.updateCarList(carList)
                // commit('setCarList', carList);
                this.updatePriceGroupByIntervalType(priceGroupByIntervalType)
                // commit('setPriceGroupByIntervalType', priceGroupByIntervalType);
                this.updateCarListShow(true);
                // commit('setCarListShow', true);
                this.updateOldTransactionKey(oldTransactionKey);
                // commit('setOldTransactionKey', oldTransactionKey)
              }).catch(err => {
            this.$message({
              type: 'error',
              message: err.message
            });
          })
        }

      },
      async updateLanguage() {
        console.log("初始化语言");
        try {
          let language = this.$cookies.get("sbox-l")
          if (!language || language === undefined || language == null) {
            this.$i18n.locale = 'en';
            return;
          }
          this.$i18n.locale = language;
        } catch (e) {
          this.$i18n.locale = 'en';
        }
      }
    },
  }
  </script>
<style scoped>

.content {
  font-family: Arial, sans-serif;
  height: auto;
  -ms-overflow-style: none; /* IE 10+ */
  scrollbar-width: none; /* Firefox */
}

.content::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.indexHeader {
  position: relative;
  width: 100%;
  height: 300px !important;
  opacity: 1;

  display: flex;
  flex-direction: row;
  background-color: #FB713C;
  padding: 0;
}

.headerText {
  flex: 2
}

.headerImg {
  flex: 1;
  width: 300px !important;
  height: 300px !important;
  background-image: url("https://fronted.familypro.io/familypro/fronted/resource/banner-person-nobg.svg");
  background-size: contain;
  background-position: bottom;
  background-repeat: no-repeat;
}

.sage-content {
  position: relative;
  left: 22%;
  top: 92px;
  width: 492px;
  height: 38px;
  opacity: 1;
  font-family: 'Alibaba Sans', sans-serif !important;
  font-size: 38px !important;
  font-weight: bold !important;
  line-height: 38px !important;
  letter-spacing: 0px !important;
  font-variation-settings: "opsz" auto;
  color: #FFFFFF !important;
}

.sage-content-sub {
  position: relative !important;
  left: 22% !important;
  top: 100px !important;
  width: 820px !important;
  height: 84px !important;
  opacity: 1;
  font-family: 'Alibaba Sans', sans-serif !important;
  font-size: 30px !important;
  font-weight: 500 !important;
  line-height: 42px !important;
  letter-spacing: 0px !important;
  text-align: left !important;
  font-variation-settings: "opsz" auto;
  color: #FFBBA1 !important;
}

.headerText h1 {
  margin: 0;
  font-size: 2.5rem;
  width: 100%;
}

.headerText p {
  margin: 10px 0 0;
  font-size: 1.2rem;
  width: 100% !important;
}

.blog-card {
  margin-top: 51px;
}

.comments-content {
  padding: 0 !important;
  margin-top: 51px;
}

.faq-content {
  margin-top: 55px;
}

.goods-content {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(128, 128, 128, 0.5); /* 背景透明 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999 !important;
}

.goods-content * {
  opacity: 1; /* 子元素不透明 */
}

.goods-content > :not(.background) {
  opacity: 1;
}

.loadingFlag {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 1024px) {
  .sage-content {
    top: 56px;
  }

  .sage-content-sub {
    top: 59px;
  }

}

@media (max-width: 768px) {

  .content {
    margin-top: 0vh !important;
  }

  .indexHeader {
    height: 30vw; /* 根据需要调整高度 */
  }

  .headerText h1 {
    font-size: 1.8rem;
  }

  .headerText p {
    font-size: 1rem;
  }


  .sage-content {
    position: relative !important;
    left: 3rem !important;
    top: 92px !important;
    font-family: 'Alibaba Sans', sans-serif !important;
    font-size: 32px !important;
    font-weight: bold !important;
    line-height: 38px !important;
    letter-spacing: 0px;

    width: 292px;
    height: 44px;


  }

  .sage-content-sub {
    position: relative !important;
    left: 3rem !important;
    top: 119px !important;
    font-size: 25px !important;
    font-weight: 500 !important;
    line-height: 32px !important;
    letter-spacing: 0px;
    width: 208px;
    height: 52px;
    opacity: 1;
    letter-spacing: 0px;

  }

  .goods-content {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(128, 128, 128, 0.5); /* 背景透明 */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .goods-content * {
    opacity: 1; /* 子元素不透明 */
  }

  .goods-content > :not(.background) {
    opacity: 1;
  }

  .faq-content {
    margin-top: 55px;
  }
}

@media (max-width: 767px) {
  .indexHeader {
    height: 200px !important;
  }
  .sage-content {
    top: 10px !important;
  }
  .sage-content-sub {
    top: 45px !important;
  }
  .headerImg {
    height: 200px !important;
    width: 200px !important;
  }
}

@media (max-width: 623px) {

  .sage-content {
    /* top: 17px !important; */
  }

  .sage-content-sub {
    /* top: 42px !important; */
  }


}

@media (max-width: 430px) {

  .sage-content-sub {
    /* top: 26px; */
  }

  .sage-content, .sage-content-sub {
    position: relative !important;
    left: 1rem !important;
    /* top: 31px !important; */
    letter-spacing: 0;
  }

  .sage-content {
    font-size: 22px !important;
    height: 54px;
    /* top: 16px !important; */
  }

  .sage-content-sub {
    font-size: 18px !important;
    width: 17rem !important;
  }
}

@media (max-width: 390px) {
  .sage-content {
    font-size: 22px !important;
  }

  .sage-content-sub {
    font-size: 18px !important;
  }
}

@media (max-width: 375px) {

  .sage-content {
  }

  .sage-content-sub {
    /* top: 35px !important; */
  }
}

@media (max-width: 320px) {
  .sage-content {
    line-height: 26px !important;
  }

  .sage-content-sub {
    line-height: 25px !important;
  }




}
</style>